class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
    this._loaded = false;
    this._loading = false;
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    document.addEventListener('quickview:open', (e) => {
      if (e && e.detail && e.detail.productUrl === this.dataset.productUrl) {
        this.load();
      }
    });
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;
    this.load();
  }

  showDiag(reason) {
    // SOHA nem zarunk be es nem navigalunk: a modalban mutatjuk meg, mi tortent.
    try {
      const dc = this.querySelector('.quick-view__content');
      if (!dc) { console.error('[quick-view] nincs .quick-view__content', reason); return; }
      const url = (this.dataset && this.dataset.productUrl) ? this.dataset.productUrl : '#';
      dc.innerHTML = '<div style="padding:4rem 2rem;text-align:center;font-size:1.5rem;line-height:1.6">' +
        '<p style="margin:0 0 1rem"><strong>A gyorsn\u00e9zet bet\u00f6lt\u00e9se elakadt.</strong></p>' +
        '<p style="margin:0 0 2rem;color:#666">Diagn\u00f3zis: <code>' + String(reason).replace(/</g,'&lt;') + '</code></p>' +
        '<a href="' + url + '" style="display:inline-block;border:2px solid #334B4A;color:#334B4A;padding:1rem 2.4rem;text-decoration:none;letter-spacing:0.15em;text-transform:uppercase;font-size:1.2rem">Megnyit\u00e1s term\u00e9koldalon</a>' +
        '</div>';
      dc.classList.add('hide-cover');
    } catch (e) { console.error('[quick-view] diag hiba', e); }
  }

  load() {
    if (this._loaded || this._loading) return;
    this._loading = true;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    if (!drawerContent) { this._loading = false; this.showDiag('NO_DRAWER_CONTENT'); return; }
    if (!this.dataset.productUrl) { this._loading = false; this.showDiag('NO_PRODUCT_URL'); return; }

    const productUrl = this.dataset.productUrl.split('?')[0];
    const plainUrl = `${productUrl}?view=modal`;

    const parseContent = (responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const el = responseHTML.querySelector(selector);
      return (el && el.innerHTML.trim()) ? el : null;
    };

    fetch(plainUrl, { cache: 'reload' })
      .then(response => {
        if (response.url && response.url.indexOf('/password') > -1) {
          this._loading = false;
          this.showDiag('PASSWORD_REDIRECT (lej\u00e1rt bolt-jelsz\u00f3 munkamenet)');
          return null;
        }
        if (!response.ok) {
          this._loading = false;
          this.showDiag('HTTP_' + response.status);
          return null;
        }
        return response.text().then(parseContent);
      })
      .then(productElement => {
        if (productElement === null || productElement === undefined) {
          if (this._loading) { this._loading = false; this.showDiag('NO_MODAL_CONTENT (a v\u00e1lasz nem tartalmaz modal-sablont)'); }
          return;
        }
        this._loading = false;
        this._loaded = true;

        this.setInnerHTML(drawerContent, productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawerContent.classList.add('hide-cover');

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            }));
          });
        });
      })
      .catch(e => {
        console.error('[quick-view]', e);
        this._loading = false;
        this.showDiag('FETCH_ERROR: ' + (e && e.message ? e.message : e));
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
